export interface RestartDeclarationSuccess {
  type: 'success';
}

export interface RestartDeclarationCancel {
  type: 'cancel';
}

export type RestartDeclarationOutputData =
  | RestartDeclarationCancel
  | RestartDeclarationSuccess;
